import { Button, Col, Row, Space, Typography } from "antd";
import CompanyDepartmentsView from "../components/CompanyDepartmentsView";
import { useState } from "react";
import { DepartmentForm } from "../components/DepartmentFormDialog.default";
import { Guid } from "guid-typescript";
import DepartmentFormDialog from "../components/DepartmentFormDialog";

function CompanyDepartmentsPage() {
  const [departmentInputMode, setDepartmentInputMode] = useState<
    "add" | "update" | "delete"
  >("add");
  const [departmentInputOpen, setDepartmentInputOpen] = useState(false);
  const [departmentInputValues, setDepartmentInputValues] = useState<
    DepartmentForm | undefined
  >(undefined);
  const [triggerView, setTriggerView] = useState(Guid.create().toString());

  function onDepartmentInputOpen(
    mode: "add" | "update" | "delete",
    values?: DepartmentForm,
  ): void {
    setDepartmentInputMode(mode);
    setDepartmentInputOpen(true);
    setDepartmentInputValues(values);
  }

  function onDepartmentInputFinish(): void {
    setDepartmentInputOpen(false);
    setTriggerView(Guid.create().toString());
  }

  function onDepartmentInputClose(): void {
    setDepartmentInputOpen(false);
  }

  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <Row className="sticky top-0 z-10 flex flex-row flex-wrap items-center p-4">
        <Typography.Title className="m-0 flex-auto" level={4}>
          Departments
        </Typography.Title>
        <Space className="flex flex-row">
          <Button type="primary" onClick={() => onDepartmentInputOpen("add")}>
            Add Department
          </Button>
        </Space>
      </Row>
      <Col className="flex flex-auto flex-col overflow-hidden p-4 pb-4 pt-0">
        <CompanyDepartmentsView
          trigger={triggerView}
          onAction={(key: string, record: any) =>
            onDepartmentInputOpen(key as any, record)
          }
        />
      </Col>
      <DepartmentFormDialog
        key={departmentInputMode}
        mode={departmentInputMode}
        open={departmentInputOpen}
        initialValues={departmentInputValues}
        onFinish={onDepartmentInputFinish}
        onCancel={onDepartmentInputClose}
      />
    </Col>
  );
}

export default CompanyDepartmentsPage;
